// START_MODULE landing_sections
// START_CONTRACT
// PURPOSE: Define the maintained anchor targets exposed by the landing page navigation.
// OPERATIONAL_CONTEXT: Shared by section containers, smooth links, and active-section detection.
// CONTRACT: Every value except MAIN must correspond to a visible landing section and menu label.
// KEYWORDS: navigation, anchors, sections
// COMPLEXITY: 1
// END_CONTRACT
export enum Section {
  MAIN = 'main',
  DESCRIPTION = 'description',
  ANNOUNCEMENTS = 'announcements',
  GALLERY = 'gallery',
  STATISTICS = 'statistics',
  NEWS = 'news',
  CONTACTS = 'contacts',
}
// END_MODULE landing_sections
